import axios from "axios";
import { User } from "@/api/User";
import { HttpClient } from "@/api/http-client";
import { App } from "@/api/App";
import { Common } from "@/api/Common";
import { Company } from "@/api/Company";
import { Contactus } from "@/api/Contactus";
import { Dashboard } from "@/api/Dashboard";
import { Payment } from "@/api/Payment";
import { getServerBaseApiUrl } from "@/api/apiBaseUrl";

export function getRestApiClient(token?: string) {
	const axiosInstance = axios.create();

	if (token) {
		axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
	} else {
		axiosInstance.defaults.headers.Authorization = "";
	}

	const httpClient = new HttpClient({
		baseURL: getServerBaseApiUrl(true),
	});

	httpClient.instance = axiosInstance;

	return {
		user: new User(httpClient),
		app: new App(httpClient),
		common: new Common(httpClient),
		company: new Company(httpClient),
		contactus: new Contactus(httpClient),
		dashboard: new Dashboard(httpClient),
		payment: new Payment(httpClient),
	};
}
